(function() {
    'use strict';
    angular.module('voyageReport')
        .config(config);

    function config($stateProvider) {
        $stateProvider.state('voyageReport', {
            url: '/voyage-report',
            views: {
                'voyageReportView': {
                    templateUrl: 'voyage-report/views/voyage-report.tpl.html',
                    controller: 'VoyageReportCtrl',
                    controllerAs: 'voyageReport'
                }
            }
        });
    }
}());